import { render, staticRenderFns } from "./CaseDispatch.vue?vue&type=template&id=1a763414&scoped=true&scoped=true&"
import script from "./CaseDispatch.vue?vue&type=script&lang=js&"
export * from "./CaseDispatch.vue?vue&type=script&lang=js&"
import style0 from "./CaseDispatch.vue?vue&type=style&index=0&id=1a763414&scoped=true&lang=css&"
import style1 from "./CaseDispatch.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a763414",
  null
  
)

export default component.exports